import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  collapseRow: {
    paddingBlock: 21,
    paddingInline: 16,
    borderTop: `1px solid ${token.colorSplit}`,
    borderRight: `1px solid ${token.colorSplit}`,
    width: '25%',
    height: 64,
    alignItems: 'center'
  },
  padding: {
    marginBottom: 16
  },
  actions: {
    borderTop: `1px solid ${token.colorSplit}`,
    padding: 16,
    width: '50%',
    justifyContent: 'flex-end'
  },
  collapseWrapper: {
    border: `1px solid ${token.colorSplit}`,
    borderTop: 'none'
  },
  collapseMarginBottom: {
    marginBottom: 16
  }
}))
